<template>
  <div class="table-wrap">
    <table class="table" :class="[type]">
      <tr>
        <th v-for="(item,index) in head" :key="index">{{item.label}}</th>
      </tr>

      <tr v-for="(list,ind) in body" :key="ind">
        <td v-for="(item,index) in head" :key="index">
          <slot :name="item.value" :data="list" :index="ind">{{list[item.value]}}</slot>
        </td>
      </tr>

      <tr class="amount" v-if="amount">
        <td v-for="(column, inde) in total" :key="'head' + inde">
          <slot :name="'amount_' + column.value" :column="column">
            {{reduceArr(column.list)}}
          </slot>
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
  export default {
    name: "c_table",
    props: {
      head: {
        type: Array,
        default: () => ([])
      },
      type: String,
      body: {
        type: Array,
        default: () => ([])
      },
      amount: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getColumnsByKey(key) {
        return this.body.map(item => item[key]);
      },
      reduceArr(arr) {
        const plus = arr.reduce((prev, cur) => {
          return parseFloat(prev) + parseFloat(cur);
        }, 0);
        return plus.toString() === 'NaN' ? '—' : plus;
      }
    },
    computed: {
      total() {
        return this.head.map(item => {
          return {
            value: item.value,
            list: this.getColumnsByKey(item.value)
          }
        });
      }
    },
  }
</script>

<style lang="stylus" scoped>
#table-stat th,#table-stat td {
    padding: 3px;
    font-size: 10px;
}
.black-bg #table-stat th{padding:8px 3px 8px 3px !important;background:#514532}
.black-bg #table-stat th,.black-bg #table-stat td{color:white}
.black-bg #table-stat th:first-child{width:60px}
.table-queue tr:first-child {
    display: none;
}
.table-queue tr td {
    padding: 6px;
}
  .table {
    width: 100%;
    color: #000000;

    .amount {
      font-weight bold
    }

    td {
      font-size: 12px;
    }

    td,
    th {
      padding 3px
      vertical-align: middle;
      text-align left;
      border-collapse: collapse;
      border: solid 1px #e6e6e6;
      box-sizing border-box;
      text-align:center
    }

    th {
      padding 3px
      background: #f8f8f8;
      font-size: 14px;
      font-weight bold;
      text-align:center;
    }

    &.small {
      td,
      th {
        padding: 0px;
      }

      th {
        padding: 3px 2px;
        font-size: 12px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/table.vue